function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "38",
  height: "24",
  viewBox: "0 0 29 17",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "button/slider/zustandfuture-copy-6",
  transform: "translate(-10 -16)",
  fill: "#FFF",
  strokeWidth: "0",
  className: styles["bike"] || "bike"
}, /*#__PURE__*/React.createElement("g", {
  id: "noun_1010574_cc",
  transform: "translate(11 17)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.991 3.185l-.545-1.559h-.5a.813.813 0 010-1.626h2.44a.813.813 0 010 1.626h-.217l.285.814h6.03v-.203a2.238 2.238 0 014.473-.002v.238a.813.813 0 01-1.626 0v-.238a.61.61 0 00-1.22.002v2.81a4.473 4.473 0 013.086 8.37l4.64.001a.813.813 0 010 1.627H.812a.813.813 0 010-1.627H4.64a4.473 4.473 0 013.687-8.152L9.99 3.185zm6.208.881h-4.176l1.271 3.631 2.905-3.63zm1.996 3.404a2.846 2.846 0 101.379-.863l1.446 2.314a.813.813 0 01-1.379.862L18.195 7.47zm-10.94-.865A2.85 2.85 0 003.66 9.352a2.846 2.846 0 005.574.813H6.1a.813.813 0 01-.635-1.32l1.791-2.24zm1.389.868L7.79 8.54h1.443a2.841 2.841 0 00-.59-1.066zm1.981-2.477L9.67 6.191a4.462 4.462 0 011.235 2.348h.96l-1.24-3.543zm2.37 5.17h-2.09a4.48 4.48 0 01-2.533 3.252h10.093a4.473 4.473 0 01-.98-7.516v-.839L13.65 9.854a.817.817 0 01-.657.311z",
  id: "Shape"
}))))));